module.exports = "https://trybtryb-legacy.web.app/img/header.d2f89b5d.svg";